import queryString from 'query-string'

export const useDeeplink = () => {
  const {
    utm_source,
    utm_campaign,
    utm_content,
    abExternalOpen,
    landing,
    variant,
    u,
    e,
    t,
    h,
    promo,
    theme,
    programId,
    from,
    gender,
    telehealth,
    prescreen,
    auth,
  } = queryString.parse(window.location.search, {
    decode: false,
  })

  return {
    fitonUserId: u,
    email: e,
    t,
    h,
    utmSource: utm_source ? decodeURIComponent(utm_source) : '',
    utmCampaign: utm_campaign,
    utmContent: utm_content,
    abExternalOpen,
    landing,
    variant,
    promo,
    theme: theme ? decodeURIComponent(theme) : '',
    programId,
    from,
    gender,
    telehealth,
    prescreen,
    // 'login' | 'signup' — which auth view the MCA "Get Started" opens
    // (CARE-158). Campaign links aimed at existing FitOn members append
    // auth=login; see Welcome.js's redirectToMedicareSignup.
    auth,
  }
}
